var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 992,
    height: 507,
    viewBox: "0 0 992 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_671_9749",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -345,
    width: 992,
    height: 992
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -345,
    width: 992,
    height: 992,
    fill: "url(#paint0_linear_671_9749)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_671_9749)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    cx: 496,
    cy: 151,
    r: 111.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 496,
    cy: 151,
    r: 159.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 496,
    cy: 151,
    r: 207.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 496,
    cy: 151,
    r: 255.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 496,
    cy: 151,
    r: 303.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 496,
    cy: 151,
    r: 351.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 496,
    cy: 151,
    r: 399.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 496,
    cy: 151,
    r: 447.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 496,
    cy: 151,
    r: 495.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496,
    cy: 151,
    r: 63.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_671_9749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587 163.05C587 160.813 588.813 159 591.05 159H604L617 172.163V195.45C617 197.687 615.187 199.5 612.95 199.5H591.05C588.813 199.5 587 197.687 587 195.45V163.05Z",
    fill: "#E5252A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.25 172.163H617.375L604.213 159V169.125C604.213 170.803 605.573 172.163 607.25 172.163Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M593 190.398V183H596.061C596.819 183 597.42 183.213 597.872 183.648C598.325 184.073 598.551 184.65 598.551 185.368C598.551 186.087 598.325 186.663 597.872 187.088C597.42 187.524 596.819 187.736 596.061 187.736H594.841V190.398H593ZM594.841 186.127H595.854C596.13 186.127 596.347 186.066 596.494 185.925C596.642 185.793 596.721 185.611 596.721 185.368C596.721 185.125 596.642 184.943 596.494 184.811C596.347 184.67 596.13 184.609 595.854 184.609H594.841V186.127ZM599.309 190.398V183H601.859C602.361 183 602.833 183.071 603.276 183.223C603.719 183.374 604.123 183.587 604.477 183.88C604.831 184.164 605.117 184.548 605.323 185.034C605.52 185.52 605.629 186.076 605.629 186.704C605.629 187.321 605.52 187.878 605.323 188.363C605.117 188.849 604.831 189.234 604.477 189.517C604.122 189.811 603.719 190.023 603.276 190.175C602.833 190.327 602.361 190.398 601.859 190.398H599.309ZM601.111 188.789H601.642C601.928 188.789 602.193 188.758 602.439 188.687C602.676 188.616 602.902 188.505 603.119 188.353C603.325 188.202 603.493 187.989 603.611 187.706C603.729 187.422 603.788 187.088 603.788 186.704C603.788 186.309 603.729 185.975 603.611 185.692C603.493 185.409 603.325 185.196 603.119 185.044C602.902 184.892 602.676 184.781 602.439 184.71C602.193 184.639 601.928 184.609 601.642 184.609H601.111V188.789ZM606.554 190.398V183H611.672V184.609H608.394V185.793H611.013V187.392H608.394V190.398H606.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.233 24.5723C665.708 24.5723 664.471 25.8085 664.471 27.3336V62.3099C664.471 63.8349 665.708 65.0712 667.233 65.0712H691.164C692.689 65.0712 693.925 63.8349 693.925 62.3099V35.6174L682.88 24.5723H667.233Z",
    fill: "#F4B70A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.926 45.052V35.6176L692.315 34.0068H684.548C683.933 34.0068 683.625 34.7504 684.059 35.1853L693.926 45.052Z",
    fill: "url(#paint1_linear_671_9749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.88 24.5723L693.926 35.6174H685.642C684.117 35.6174 682.88 34.3812 682.88 32.8561V24.5723Z",
    fill: "#FADC87"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.756 42.9805C672.247 42.9805 671.835 43.3926 671.835 43.9009V56.7869C671.835 57.2953 672.247 57.7073 672.756 57.7073H685.641C686.15 57.7073 686.562 57.2953 686.562 56.7869V43.9009C686.562 43.3926 686.15 42.9805 685.641 42.9805H672.756ZM684.721 47.1224H673.676V53.5654H684.721V47.1224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.159 68.5723C388.634 68.5723 387.397 69.8085 387.397 71.3336V106.31C387.397 107.835 388.634 109.071 390.159 109.071H414.09C415.615 109.071 416.851 107.835 416.851 106.31V79.6174L405.806 68.5723H390.159Z",
    fill: "#20A464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.852 89.052V79.6176L415.241 78.0068H407.474C406.859 78.0068 406.551 78.7504 406.985 79.1853L416.852 89.052Z",
    fill: "url(#paint2_linear_671_9749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.807 68.5723L416.852 79.6174H408.568C407.043 79.6174 405.807 78.3812 405.807 76.8561V68.5723Z",
    fill: "#8ED1B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.488 88.3618V101.708H394.761V88.3618H409.488ZM401.204 90.2027H396.602V92.5038H401.204V90.2027ZM403.045 92.5038V90.2027H407.647V92.5038H403.045ZM401.204 93.8844H396.602V96.1855H401.204V93.8844ZM403.045 96.1855V93.8844H407.647V96.1855H403.045ZM401.204 97.5661H396.602V99.8672H401.204V97.5661ZM403.045 99.8672V97.5661H407.647V99.8672H403.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_671_9749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279 172.05C279 169.813 280.813 168 283.05 168H296L309 181.163V204.45C309 206.687 307.187 208.5 304.95 208.5H283.05C280.813 208.5 279 206.687 279 204.45V172.05Z",
    fill: "#FFAB49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.25 181.163H309.375L296.213 168V178.125C296.213 179.803 297.573 181.163 299.25 181.163Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.841 197.564C286.532 197.848 286.511 198.328 286.795 198.637C287.078 198.946 287.558 198.967 287.867 198.684L286.841 197.564ZM291.414 194.402L291.928 194.962L291.928 194.962L291.414 194.402ZM292.422 194.385L291.928 194.962L291.928 194.962L292.422 194.385ZM296.732 199.08C297.05 199.353 297.53 199.316 297.803 198.998C298.076 198.679 298.039 198.2 297.72 197.927L296.732 199.08ZM295.171 196.584C294.874 196.881 294.874 197.362 295.171 197.658C295.467 197.955 295.948 197.955 296.244 197.658L295.171 196.584ZM297.52 195.309L296.983 194.772L297.52 195.309ZM298.513 195.238L298.968 194.631L298.968 194.631L298.513 195.238ZM300.567 197.729C300.903 197.98 301.379 197.912 301.631 197.577C301.882 197.241 301.814 196.765 301.479 196.514L300.567 197.729ZM288.493 188.252H299.884V186.733H288.493V188.252ZM299.884 188.252C300.094 188.252 300.264 188.422 300.264 188.632H301.782C301.782 187.583 300.933 186.733 299.884 186.733V188.252ZM300.264 188.632V200.022H301.782V188.632H300.264ZM300.264 200.022C300.264 200.232 300.094 200.402 299.884 200.402V201.921C300.933 201.921 301.782 201.071 301.782 200.022H300.264ZM299.884 200.402H288.493V201.921H299.884V200.402ZM288.493 200.402C288.284 200.402 288.114 200.232 288.114 200.022H286.595C286.595 201.071 287.445 201.921 288.493 201.921V200.402ZM288.114 200.022V188.632H286.595V200.022H288.114ZM288.114 188.632C288.114 188.422 288.284 188.252 288.493 188.252V186.733C287.445 186.733 286.595 187.583 286.595 188.632H288.114ZM287.867 198.684L291.928 194.962L290.901 193.842L286.841 197.564L287.867 198.684ZM291.928 194.962L291.928 194.962L292.916 193.809C292.333 193.309 291.468 193.323 290.901 193.842L291.928 194.962ZM291.928 194.962L296.732 199.08L297.72 197.927L292.916 193.809L291.928 194.962ZM296.244 197.658L298.057 195.846L296.983 194.772L295.171 196.584L296.244 197.658ZM298.057 195.846L298.057 195.846L298.968 194.631C298.363 194.177 297.517 194.237 296.983 194.772L298.057 195.846ZM298.057 195.846L300.567 197.729L301.479 196.514L298.968 194.631L298.057 195.846ZM297.986 191.29C297.986 191.709 297.646 192.049 297.226 192.049V193.568C298.484 193.568 299.504 192.548 299.504 191.29H297.986ZM297.226 192.049C296.807 192.049 296.467 191.709 296.467 191.29H294.948C294.948 192.548 295.968 193.568 297.226 193.568V192.049ZM296.467 191.29C296.467 190.87 296.807 190.53 297.226 190.53V189.011C295.968 189.011 294.948 190.031 294.948 191.29H296.467ZM297.226 190.53C297.646 190.53 297.986 190.87 297.986 191.29H299.504C299.504 190.031 298.484 189.011 297.226 189.011V190.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_671_9749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194 26.05C194 23.8132 195.813 22 198.05 22H211L224 35.1625V58.45C224 60.6868 222.187 62.5 219.95 62.5H198.05C195.813 62.5 194 60.6868 194 58.45V26.05Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.25 35.1625H224.375L211.213 22V32.125C211.213 33.8026 212.573 35.1625 214.25 35.1625Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_671_9749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.151 44.1511L201.595 48.8714L206.151 53.2636M212.226 44.1511L216.782 48.8714L212.226 53.2636M210.707 40.7339L208.05 55.9214",
    stroke: "white",
    strokeWidth: 1.51875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M782.085 125.572C780.56 125.572 779.323 126.809 779.323 128.334V163.31C779.323 164.835 780.56 166.071 782.085 166.071H806.016C807.541 166.071 808.777 164.835 808.777 163.31V136.617L797.732 125.572H782.085Z",
    fill: "#4E8DF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.778 146.052V136.618L807.167 135.007H799.399C798.784 135.007 798.476 135.75 798.911 136.185L808.778 146.052Z",
    fill: "url(#paint3_linear_671_9749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.732 125.572L808.778 136.617H800.494C798.969 136.617 797.732 135.381 797.732 133.856V125.572Z",
    fill: "#A6C5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.414 145.822H786.687V147.663H801.414V145.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.414 149.503H786.687V151.344H801.414V149.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.687 153.185H801.414V155.026H786.687V153.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.732 156.867H786.687V158.708H797.732V156.867Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_671_9749",
    x1: 496,
    y1: -345,
    x2: 496,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.437233,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662338,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_671_9749",
    x1: 688.891,
    y1: 45.052,
    x2: 688.891,
    y2: 33.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B70A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2930A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_671_9749",
    x1: 411.817,
    y1: 89.052,
    x2: 411.817,
    y2: 77.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#207E55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_671_9749",
    x1: 803.255,
    y1: 146.052,
    x2: 803.255,
    y2: 134.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E8DF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D6ACD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_671_9749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.375,
    height: 40.5,
    fill: "white",
    transform: "translate(587 159)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_671_9749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.375,
    height: 40.5,
    fill: "white",
    transform: "translate(279 168)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_671_9749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.375,
    height: 40.5,
    fill: "white",
    transform: "translate(194 22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_671_9749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.225,
    height: 18.225,
    fill: "white",
    transform: "translate(200.076 39.2148)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.b2e30a080645db1cb9b8a5f1f8683c5b.svg";
export { ForwardRef as ReactComponent };